import { Nullable } from '@/utils/types';

const WHITE_BACKGROUNDS = ['rgb(255, 255, 255)', 'white', '#fff', '#ffffff'];
const NO_BACKGROUNDS = ['transparent', 'inherit', 'initial', 'unset', 'currentcolor'];
const HIGHLIGHT_TEXT_COLOR = 'rgba(0, 0, 0, 0.87)';

export function stripNbsp (html?: Nullable<string>): string {
  if (!html) return '';
  return html.replace(/&nbsp;/g, ' ').replace(/\u00A0/g, ' ');
}

// Rich text is drawn in the theme's text colour (white in dark mode). Text pasted from a white page
// keeps an inline white background, which hides it there, so that background is dropped; a real
// highlight stays and gets dark text unless it sets its own colour.
export function makeInlineBackgroundsReadable (root: HTMLElement): void {
  root.querySelectorAll<HTMLElement>('[style]').forEach((element) => {
    const background = element.style.backgroundColor.replace(/\s+/g, ' ').trim().toLowerCase();

    if (!background || NO_BACKGROUNDS.includes(background) || /^rgba\(.*, 0\)$/.test(background)) return;

    if (WHITE_BACKGROUNDS.includes(background)) {
      element.style.removeProperty('background-color');
    } else if (!element.style.color || element.style.color === 'inherit') {
      element.style.color = HIGHLIGHT_TEXT_COLOR;
    }
  });
}
